import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = m[1];

    const exchange = async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        // Store session token as JWT-like (for Authorization fallback)
        if (res.data.session_token) {
          localStorage.setItem("amazypet_token", res.data.session_token);
        }
        if (res.data.user) setUser(res.data.user);
        // clear hash and go to account
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <p className="overline">Authenticating…</p>
    </div>
  );
};

export default AuthCallback;
